import React, { createContext, useContext, useState, useCallback} from "react";
import {fetchCustomers as fetchCustomersApi} from "./api/api"
import { useAuthenticatedEffect } from "./components/useauthenticatedeffect";

const CustomerContext = createContext();

export const useCustomers = () => useContext(CustomerContext);

export const CustomerProvider = ({children}) => {
    const [customers, setCustomers] = useState([]);

    // fetches customer and updates state
    const fetchCustomers = useCallback(async () => {
        try {
            const fetchedCustomers = await fetchCustomersApi();
            setCustomers(fetchedCustomers);
        } catch (error) {
            console.error('Error fetching customers from context:', error);
        }
    }, []); //empty dependency array, useCallback is for memoization to ensure fetchCustomers is not recreated on every render

    // useAuthenticatedEffect(() => {
    //     fetchCustomers().then(r => r); // added then(r => r) to remove warning
    // }); //useAuthenticatedEffect is a custom hook that ensures the effect is only run when the user is authenticated

    useAuthenticatedEffect(
        useCallback(() => {
            fetchCustomers().then(r => r); // added then(r => r) to remove warning
        }, [fetchCustomers])  //useAuthenticatedEffect is a custom hook that ensures the effect is only run when the user is authenticated
    );

    const updateBalanceInState = useCallback((customerId, newBalance) => {
        console.log(`Updating balance for customer ${customerId} to ${newBalance}`)
        setCustomers((currentCustomers) =>
            currentCustomers.map((customer) =>
                customer.id === customerId ? { ...customer, customer_balance: newBalance } : customer));
    },[]); //empty dependency array, useCallback is for memoization to ensure updateBalanceInState is not recreated on every render


    //add any other customer-related global functions here
    const value = {
        customers,
        fetchCustomers,
        updateBalanceInState,
    };

    return <CustomerContext.Provider value={value}>{children}</CustomerContext.Provider>;

}